<template>
  <div id="">
    <!-- <div>
      <span>学段：</span>
      <span
        class="carry_stage"
        :class="{ stageA: item.code === stageCode }"
        @click="stageClick(item.code)"
        v-for="item in stageList"
        :key="item.code"
        >{{ item.name }}</span
      >
    </div> -->
    <phase-studying @stageClickEmit="stageClick" @stageEmit="changeStage"></phase-studying>
    <el-form style="margin-top: 20px" :inline="true" class="demo-form-inline">
      <el-form-item>
        <el-input maxlength="20" size="small" v-model="schoolName" placeholder="请输入学校名称"
          @keyup.enter.native="schoolPeopleList"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="schoolPeopleList">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="exportSchoolList">导出汇总</el-button>
      </el-form-item>
    </el-form>
    <!-- 表格区域 -->
    <el-table :row-style="{ height: '48px' }" :header-cell-style="{ background: '#f5f5f5', height: '48px' }"
      :data="schoolList" stripe border style="width: 100%">
      <el-table-column type="index" align="center" label="序号" width="50">
      </el-table-column>
      <el-table-column align="center" prop="provinceName" label="省份">
      </el-table-column>
      <el-table-column align="center" prop="cityName" label="城市">
      </el-table-column>
      <el-table-column align="center" prop="countyName" label="区县">
      </el-table-column>
      <el-table-column align="center" prop="schoolName" label="学校名称">
      </el-table-column>
      <el-table-column prop="areaAttribute" label="地区属性" align="center">
        <template slot-scope="scope">
          {{
            getNameById(scope.row.areaAttribute, attributelist, 'code', 'name')
          }}
        </template>
      </el-table-column>
      <!-- <el-table-column align="center" prop="schoolType" label="学校类型">
      </el-table-column> -->
      <el-table-column align="center" prop="count" label="学生总数">
      </el-table-column>
      <el-table-column align="center" prop="studentActiveCount" label="学生激活人数">
      </el-table-column>
      <!-- <el-table-column align="center" prop="schoolName" label="激活占比">
      </el-table-column> -->
      <el-table-column align="center" prop="teacherCount" label="教师人数">
      </el-table-column>
      <el-table-column align="center" prop="teacherActiveCount" label="教师激活人数">
      </el-table-column>
      <!-- <el-table-column align="center" prop="schoolName" label="激活占比">
      </el-table-column> -->
      <el-table-column align="center" prop="scanCardCount" label="课堂评价次数">
      </el-table-column>
      <el-table-column width="240" align="center" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="viewSchool(scope.row.schoolId)">查看学校大数据</el-button>
          <!-- <el-button type="text" @click="viewObservation(scope.row)"
            >查看评价观测体系</el-button
          > -->
          <el-button type="text" @click="toZp(scope.row)">管理登录</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页区域 -->
    <el-pagination style="margin-top: 20px" background layout="total,prev,pager,next,sizes" :total="totalCount"
      :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" :current-page="curPage" @size-change="handleSizeChange"
      @current-change="currentChange"></el-pagination>
  </div>
</template>
<script>
import phaseStudying from './components/phaseStudying.vue'
import {
  dictCode,
  usercenterinfo,
  schoolPeopleList,
  schoolListExport,
  bigurl,
  zpUrl,
  getSchoolToken
} from '@/api/home'
import AES from '@/assets/js/aes.js'
export default {
  components: {
    phaseStudying
  },
  data() {
    return {
      schoolId: '',
      stageList: [],
      stageCode: '',
      userInfo: {},
      curPage: 1,
      pageSize: 20,
      schoolName: '',
      schoolList: [],
      totalCount: 0,
      attributelist: [],
      bigurl: bigurl
    }
  },
  created() {
    this.dictcode()
  },
  methods: {
    getNameById(id, targetList, idName, name) {
      let result = ''
      let index = targetList.findIndex(i => {
        return i[idName] == id
      })
      if (index != -1) {
        result = targetList[index][name]
      }
      return result
    },
    dictcode() {
      let that = this
      let params = {
        code: 'area_attribute'
      }

      dictCode(params)
        .then(res => {
          that.attributelist = res.data.data
        })
        .catch(error => { })
    },
    toZp(s) {
      let params = {
        userId: s.schoolId,
        roleType: 'school'
      }
      getSchoolToken(params).then(res => {
        let token = res.data.data
        window.open(zpUrl + '?token=' + token + '&roleId=-1004', '_self')
      })
      // let html = zpUrl + '?roleId=-1005&token=' + localStorage.getItem('token')
      // window.open(html, '_self')
    },
    // 初始化学段属性
    changeStage(val) {
      this.stageCode = val
      this.usercenterinfo()
    },
    // 学段点击事件
    stageClick(code) {
      this.stageCode = code
      this.schoolPeopleList()
    },
    // 获取登陆用户信息
    async usercenterinfo() {
      const { data: res } = await usercenterinfo()
      // this.userInfo = res.data.leader
      this.schoolId = res.data.schoolId
      this.schoolPeopleList()
    },
    // 获取学校列表
    async schoolPeopleList() {
      let params = {
        page: this.curPage,
        size: this.pageSize,
        schoolName: this.schoolName,
        stage: this.stageCode,
        centralSchoolId: this.schoolId
      }

      const { data: res } = await schoolPeopleList(params)
      this.schoolList = res.data.dataList
      this.totalCount = res.data.totalCount
    },
    // 分页页码变化
    currentChange(e) {
      this.curPage = e
      this.schoolPeopleList()
    },
    // 分页一页数量变化
    handleSizeChange(val) {
      this.curPage = 1
      this.pageSize = val
      this.schoolPeopleList()
    },
    // 学校列表导出
    exportSchoolList() {
      let params = {
        stage: this.stageCode,
        schoolName: this.schoolName,
        centralSchoolId: this.schoolId
      }
      let name = ''
      this.stageList.forEach(item => {
        if (this.stageCode == item.code) {
          name = item.name
        }
      })
      name = name + '学校汇总'
      schoolListExport(params, name)
    },
    // 查看学校大数据大屏
    viewSchool(schoolId) {
      let id = AES.encrypt(schoolId.toString())
      let appCode = AES.encrypt('ZHSZPJ')
      let ids = encodeURIComponent(id)
      let appCodes = encodeURIComponent(appCode)
      // let html = this.bigurl + '/#/?appCode=' + appCodes + '&schoolId=' + ids
      let html =
        this.bigurl +
        '/#/school?token=' +
        localStorage.getItem('token') +
        '&schoolId=' +
        schoolId
      window.open(html, '_self')
    },
    // 查看学校观测数据
    viewObservation(info) {
      this.$router.push({
        path: '/observation',
        query: {
          schoolId: info.schoolId,
          schoolName: info.schoolName
        }
      })
    }
  }
}
</script>
<style scoped>
.carry_stage {
  margin-left: 20px;
  cursor: pointer;
}
.stageA {
  color: #2a8bf8;
}
</style>



// WEBPACK FOOTER //
// src/views/school/components/manage.vue